;(function () {
  function bindPlayButton(button) {
    if (button.dataset.nmAboutBound === 'true') return
    button.dataset.nmAboutBound = 'true'

    var wrapper = button.closest('.nm-about-collection__video-wrapper')
    var video = wrapper ? wrapper.querySelector('video') : null
    if (!video) return

    button.addEventListener('click', function () {
      if (video.paused) {
        video.play()
      } else {
        video.pause()
      }
    })

    video.addEventListener('play', function () {
      button.classList.add('active')
    })

    video.addEventListener('pause', function () {
      button.classList.remove('active')
    })
  }

  function initSection(root) {
    var buttons = root.querySelectorAll('.nm-about-collection .js-nm-play-video')
    buttons.forEach(bindPlayButton)
  }

  initSection(document)

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target)
  })
})()
